// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speech-to-text-wrapper {
    position: relative;
    margin-bottom: 20px;
  }
  .input-container {
    display: flex;
    align-items: center;
    position: relative;
    gap: 15px; 
  }
  
  .input-container-null {
    display: flex;
    align-items: center;
    position: relative;
    gap: 0.5rem; 
  }
  
  /* Input field styles (for both text and textarea) */
  .speech-input,
  .speech-textarea {
    width: 100%;
    padding: 12px 15px;
    font-size: 16px;
    border-radius: 8px; 
    border: 1px solid #ccc;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }
  
  /* Add focus effects to inputs */
  .speech-input:focus,
  .speech-textarea:focus {
    border-color: #4CAF50; 
    box-shadow: 0 0 8px rgba(76, 175, 80, 0.5); 
  }
  
  /* Textarea specific styling */
  .speech-textarea {
    height: 120px; 
    resize: vertical;
  }
  
  /* Microphone and stop button styling */
  .mic-button {
    /* padding: 12px; */
    border: none;
    border-radius: 50%; 
    font-size: 1.2rem; 
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.05); 
    color: #4CAF50; 
    transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
  }
  
  /* Hover effects for buttons */
  .mic-button:hover {
    transform: scale(1.3); 
    background-color: rgba(0, 0, 0, 0.1); 
  }
  
  /* Glow effect when listening */
  .mic-button.listening {
    animation: pulse 1s infinite; 
  }
  
  /* Stop button color */
  .mic-button.stop-button {
    color: #F44336; 
  }
  
  /* Pulse animation for listening state */
  @keyframes pulse {
    0% { box-shadow: 0 0 10px rgba(0, 255, 0, 0.8); }
    50% { box-shadow: 0 0 20px rgba(0, 255, 0, 1); }
    100% { box-shadow: 0 0 10px rgba(0, 255, 0, 0.8); }
}

  
  /* Subtle glow animation for the icons */
  @keyframes glow {
    0% { color: #00aaff; }
    100% { color: #ffaa00; }
  }
  
  /* Additional styling for accessibility */
  .mic-button:focus {
    outline: none;
    box-shadow: 0 0 8px rgba(76, 175, 80, 0.5); 
  }
  
  /* Compact Status container styling */
.mic-status-container {
    margin-top: 5px; 
    width: 100%;
    text-align: center;
  }
  
  /* Compact styled mic status message */
  .mic-status {
    font-size: 12px; 
    color: #555; 
    background-color: #f7f7f7; 
    padding: 4px 6px; 
    border-radius: 3px; 
    border: 1px solid #ddd; 
    display: inline-block;
    line-height: 1.2; 
  }
  
/* Style for disabled microphone button */
.disabled-mic {
  cursor: not-allowed;
  background-color: #d3d3d3; 
  color: #a0a0a0; 
}

/* Hover effect for disabled mic button */
.disabled-mic:hover {
  cursor: not-allowed; 
  color: #888888;
}

.mic-button.stop-button.disabled-mic {
  color: #b0b0b0; 
  cursor: not-allowed; 
}
`, "",{"version":3,"sources":["webpack://./src/components/SpeechRecognition/SpeechToTextInput.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA,oDAAoD;EACpD;;IAEE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,wDAAwD;EAC1D;;EAEA,gCAAgC;EAChC;;IAEE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,qCAAqC;IACrC,cAAc;IACd,iFAAiF;EACnF;;EAEA,8BAA8B;EAC9B;IACE,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA,+BAA+B;EAC/B;IACE,4BAA4B;EAC9B;;EAEA,sBAAsB;EACtB;IACE,cAAc;EAChB;;EAEA,wCAAwC;EACxC;IACE,KAAK,yCAAyC,EAAE;IAChD,MAAM,uCAAuC,EAAE;IAC/C,OAAO,yCAAyC,EAAE;AACtD;;;EAGE,wCAAwC;EACxC;IACE,KAAK,cAAc,EAAE;IACrB,OAAO,cAAc,EAAE;EACzB;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,0CAA0C;EAC5C;;EAEA,qCAAqC;AACvC;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;EAClB;;AAEF,yCAAyC;AACzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".speech-to-text-wrapper {\n    position: relative;\n    margin-bottom: 20px;\n  }\n  .input-container {\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 15px; \n  }\n  \n  .input-container-null {\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 0.5rem; \n  }\n  \n  /* Input field styles (for both text and textarea) */\n  .speech-input,\n  .speech-textarea {\n    width: 100%;\n    padding: 12px 15px;\n    font-size: 16px;\n    border-radius: 8px; \n    border: 1px solid #ccc;\n    outline: none;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  /* Add focus effects to inputs */\n  .speech-input:focus,\n  .speech-textarea:focus {\n    border-color: #4CAF50; \n    box-shadow: 0 0 8px rgba(76, 175, 80, 0.5); \n  }\n  \n  /* Textarea specific styling */\n  .speech-textarea {\n    height: 120px; \n    resize: vertical;\n  }\n  \n  /* Microphone and stop button styling */\n  .mic-button {\n    /* padding: 12px; */\n    border: none;\n    border-radius: 50%; \n    font-size: 1.2rem; \n    cursor: pointer;\n    background-color: rgba(0, 0, 0, 0.05); \n    color: #4CAF50; \n    transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;\n  }\n  \n  /* Hover effects for buttons */\n  .mic-button:hover {\n    transform: scale(1.3); \n    background-color: rgba(0, 0, 0, 0.1); \n  }\n  \n  /* Glow effect when listening */\n  .mic-button.listening {\n    animation: pulse 1s infinite; \n  }\n  \n  /* Stop button color */\n  .mic-button.stop-button {\n    color: #F44336; \n  }\n  \n  /* Pulse animation for listening state */\n  @keyframes pulse {\n    0% { box-shadow: 0 0 10px rgba(0, 255, 0, 0.8); }\n    50% { box-shadow: 0 0 20px rgba(0, 255, 0, 1); }\n    100% { box-shadow: 0 0 10px rgba(0, 255, 0, 0.8); }\n}\n\n  \n  /* Subtle glow animation for the icons */\n  @keyframes glow {\n    0% { color: #00aaff; }\n    100% { color: #ffaa00; }\n  }\n  \n  /* Additional styling for accessibility */\n  .mic-button:focus {\n    outline: none;\n    box-shadow: 0 0 8px rgba(76, 175, 80, 0.5); \n  }\n  \n  /* Compact Status container styling */\n.mic-status-container {\n    margin-top: 5px; \n    width: 100%;\n    text-align: center;\n  }\n  \n  /* Compact styled mic status message */\n  .mic-status {\n    font-size: 12px; \n    color: #555; \n    background-color: #f7f7f7; \n    padding: 4px 6px; \n    border-radius: 3px; \n    border: 1px solid #ddd; \n    display: inline-block;\n    line-height: 1.2; \n  }\n  \n/* Style for disabled microphone button */\n.disabled-mic {\n  cursor: not-allowed;\n  background-color: #d3d3d3; \n  color: #a0a0a0; \n}\n\n/* Hover effect for disabled mic button */\n.disabled-mic:hover {\n  cursor: not-allowed; \n  color: #888888;\n}\n\n.mic-button.stop-button.disabled-mic {\n  color: #b0b0b0; \n  cursor: not-allowed; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
